module.exports = "/_next/static/images/0c5f9229e880450fe07d46a8fefbf37f-rewards-app-xs@2x.png.webp";